import { db } from '@/lib/firebase';
import { collection, query, getDocs, doc, updateDoc, deleteDoc } from 'firebase/firestore';

export const AdminService = {
    // Users
    async getAllUsers() {
        const q = query(collection(db, 'users'));
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    },

    async updateUserRole(userId: string, role: 'admin' | 'user') {
        const userRef = doc(db, 'users', userId);
        await updateDoc(userRef, { role });
    },

    async deleteUser(userId: string) {
        // Note: Use Cloud Functions for full cleanup (auth + data). Client-side only deletes doc.
        await deleteDoc(doc(db, 'users', userId));
    },

    // Playlists
    async getAllPlaylists() {
        const q = query(collection(db, 'playlists'));
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    },

    async deletePlaylist(playlistId: string) {
        await deleteDoc(doc(db, 'playlists', playlistId));
    }
};
